import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-youtube",
  "use": "icon-youtube-usage",
  "viewBox": "0 0 17 12",
  "content": "<symbol viewBox=\"0 0 17 12\" id=\"icon-youtube\">\n    <g fill=\"currentColor\" fill-rule=\"evenodd\">\n        <path d=\"M3.4.727C1.942.727.756 1.87.756 3.273v5.454c0 1.404 1.186 2.546 2.644 2.546h10.2c1.458 0 2.644-1.142 2.644-2.546V3.273c0-1.404-1.186-2.546-2.644-2.546H3.4zM13.6 12H3.4C1.525 12 0 10.532 0 8.727V3.273C0 1.468 1.525 0 3.4 0h10.2C15.475 0 17 1.468 17 3.273v5.454C17 10.532 15.475 12 13.6 12z\" />\n        <path d=\"M6.8 4.183v3.634L10.07 6 6.8 4.183zm-.756 4.894V2.923L11.581 6 6.044 9.077z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/youtube.svg
// module id = 1138
// module chunks = 2